import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterCategoryMajorList = () => {
  const categoryMajorList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-category/major-list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { categoryMajorList }
}

export default InteractorMasterCategoryMajorList
